import { useTranslation } from "react-i18next";
import { Box, Button, Grid } from "@material-ui/core";
import downloadJson from "utils/downloadFile";
import DetailItem from "./DetailItem";

import { EmailFlowLogDetails, EmailFlowLogEvent } from "@dashboard-v3/api";

interface DetailsProps {
  details: EmailFlowLogDetails[];
  includeAll?: boolean;
  disableDownload?: boolean;
  showSplitRecipientStatus?: boolean;
}

export default function Details(props: DetailsProps) {
  const { details, includeAll, showSplitRecipientStatus = false } = props;
  const { emailData, msgUID } = getEmailData(details);
  const { t } = useTranslation("components");
  const smtpDeliveredEvent = details.find(
    e => e.action === "mail_smtp_delivered"
  );

  const onEventDownload = () => {
    downloadJson(details, t("emailEventDownloadName", { msgUID }));
  };

  return (
    <Grid container spacing={2}>
      {details.map(event => {
        const { action, data } = event;

        if (action === "mail_received" && data.preprocess) return null;

        return (
          <DetailItem
            key={event.eventId}
            event={event}
            recipient={emailData?.recipient}
            includeAll={includeAll}
            showSplitRecipientStatus={showSplitRecipientStatus}
            smtpDeliveredEvent={smtpDeliveredEvent}
          />
        );
      })}

      <Grid item xs={12}>
        <Box mt={2}>
          <Button
            onClick={onEventDownload}
            color="primary"
            variant="outlined"
            disabled={props.disableDownload}
          >
            {t("common:download")}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export function getEmailData(itemDetails: EmailFlowLogDetails[]) {
  const mailReceived = itemDetails.find(e => e.action === "mail_received");
  if (!mailReceived) return { emailData: null, msgUID: null };
  const { data, msgUID } = mailReceived as EmailFlowLogEvent;
  return { emailData: data, msgUID };
}
